import styles from './style.postcss';

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import * as actions from './actions';
import is from 'is_js';
import { PrivilegeChecker, ErrorDialog, connect } from 'omni-common-ui';
import { actions as groupMembersActions } from 'data/GroupMembers';
import { actions as sessionPlansActions } from 'data/SessionPlans';
import { actions as unitActions } from 'data/Units';
import { actions as apiErrorActions } from 'data/ApiError';
import { actions as userActions } from 'data/Users';
import { actions as centreActions } from 'data/Centre';
import { actions as progressTestsPlanActions } from 'data/ProgressTestsPlan';
import Privileges from 'domain/Privileges';
import PropTypes from 'prop-types';

export class Group extends Component {
  componentWillMount() {
    this._loadIfNeeded(this.props);
  }

  componentWillReceiveProps(props) {
    this._loadIfNeeded(props);
  }

  _loadIfNeeded(props) {
    const { group } = props;
    const { groupId } = props.params;

    props.fetchGroupIfNeeded(groupId);
    if (! group || ! group.data) {
      return;
    }

    props.fetchCentreIfNeeded(group.data.centreId);

    if (props.canSeeGroupMemberInfo) {
      props.fetchGroupMembersIfNeeded(groupId);
    }

    props.fetchSessionPlansIfNeeded(groupId);

    props.fetchUnitIfNeeded(groupId);

    props.fetchProgressTestPlanIfNeeded(groupId);
  }

  _isAnyLoading() {
    const { group, canSeeGroupBasicInfo } = this.props;
    const groupReady = group && group.data;
    const sessionPlansReady = groupReady && group.data.sessionPlans && group.data.sessionPlans.data;
    const summaryReady = groupReady && group.data.groupSummary;

    if (canSeeGroupBasicInfo && ! summaryReady) {
      return true;
    }

    return ! (groupReady && sessionPlansReady);
  }

  _renderErrorDialog(err) {
    return <ErrorDialog isOpen={! is.undefined(err)}
        onConfirmClick={() => this._clearErrorMessage()}
        onRequestClose={() => {}} />;
  }

  _clearErrorMessage() {
    this.props.removeApiError(this.props.pathName);
  }

  render() {
    const { children } = this.props;
    if (this._isAnyLoading()) {
      return null;
    }

    return <div className={styles.Group}>
      <div>{children}</div>
      {this._renderErrorDialog(this.props.apiError)}
    </div>;
  }
}

Group.propTypes = {
  group: PropTypes.object,
  params: PropTypes.object.isRequired,
  children: PropTypes.node,
  removeApiError: PropTypes.func.isRequired,
  fetchGroupIfNeeded: PropTypes.func.isRequired,
  fetchGroupMembersIfNeeded: PropTypes.func.isRequired,
  fetchUnitIfNeeded: PropTypes.func.isRequired,
  fetchSessionPlansIfNeeded: PropTypes.func.isRequired,
  fetchProgressTestPlanIfNeeded: PropTypes.func.isRequired,
  loginUserId: PropTypes.string,
  pathName: PropTypes.string,
  apiError: PropTypes.object,
  privileges: PropTypes.object,
  canSeeGroupMemberInfo: PropTypes.bool.isRequired,
  canSeeGroupBasicInfo: PropTypes.bool.isRequired,
};

export function mapStateToProps(state, ownProps) {
  const groupId = ownProps.params.groupId;
  const pathName = ownProps.location.pathname;
  const group = state.get('rootReducer').get('groups').get(groupId);
  const apiError = state.get('rootReducer').get('apiError').get(pathName);
  const privileges = state.get('privileges');
  const loginUserId = state.get('singleSignOn').get('user') && state.get('singleSignOn').get('user').get('profile').sub;
  const canSeeGroupMemberInfo = PrivilegeChecker.hasPrivilege(state,
      Privileges.GroupDashboard.ViewGroupMemberInfo);
  const canSeeGroupBasicInfo = PrivilegeChecker.hasPrivilege(state,
      Privileges.GroupDashboard.ViewGroupBasicInfo);
  return {
    group,
    pathName,
    apiError,
    privileges,
    loginUserId,
    canSeeGroupMemberInfo,
    canSeeGroupBasicInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({},
      bindActionCreators(actions, dispatch),
      bindActionCreators(apiErrorActions, dispatch),
      bindActionCreators(groupMembersActions, dispatch),
      bindActionCreators(sessionPlansActions, dispatch),
      bindActionCreators(unitActions, dispatch),
      bindActionCreators(userActions, dispatch),
      bindActionCreators(centreActions, dispatch),
      bindActionCreators(progressTestsPlanActions, dispatch));
}

export default connect(mapStateToProps, mapDispatchToProps)(Group);



// WEBPACK FOOTER //
// ./containers/Group/component.jsx